

import { get, post, put, destroy } from "./base";

const Deliveries = {
    index: (params) => get("/Deliveries", { params }),
    single: (id) => get(`/Deliveries/${id}`),
    create: (payload) => post("/Deliveries", payload),
    update: (id, payload) => put(`/Deliveries/${id}`, payload),
    remove: (id) => destroy(`/Deliveries/${id}`),
    sync: () => post("/Deliveries/sync"),


};

export default Deliveries;
